import urls from "../../api/urls.json";
import { authorizedHttpGet, authorizedHttpPost } from "../../api/httpCalls";
import { useState, useRef, useEffect } from "react";
import Loader from "../Loader";
import { FlexWrapper } from '../../styles/WrapperStyles'
import styled, { css } from 'styled-components';
import place_holder from '../../assests/placeholder_image.png'
import no_image_available from '../../assests/no_image.jpeg'
import PageModal from "../modals/PageModal";
import { CommonTextStyleSpan } from "../../styles/TextStyles";
import { getDate } from "../../utils";
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import EmptyView from "../EmptyView";
import '../styles/Banned.css';
import BannedOptionsModal from "../modals/BannedOptionsModal";
import { BaseButton } from "../../styles/ButtonStyles";
import chrome_icon from '../../assests/chrome_icon.png';
import delete_image from '../../assests/delete_image.png';
import heart from '../../assests/heart.png';
import add_icon from '../../assests/add_icon.png';
import crop_icon from '../../assests/crop.png';
import CropImage from '../CropImage';
import { uploadCroppedImageToS3 } from "../../api/imageUpload";
import { getSafeMediaUrl } from "../../utils";


const InputParentDiv = styled.label`
    position: relative;
    display: inline-block;
    width: 150px;
    height: 150px;
    border-radius: 15px;
    margin-right: 20px;
    background: #d7d7d7;
    cursor: pointer;
`;

const InputImage = styled.input`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const ActionButton = styled.button`
  cursor: pointer;
  width: 50px;
  height: 66px;
  border-radius: 33px;
  box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
  border: solid 1px #d7d7d7;
  background-color: #ffffff;
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #002b37;
  font-family: 'Gilory-Bold';
  ${props =>
        props.green &&
        css`
      background-color: green;
      color: white;
    `}
    ${props =>
        props.red &&
        css`
      background-color: red;
      color: white;
    `}
    ${props =>
        props.black &&
        css`
      background-color: black;
      color: white;
    `}
`;

const BottomBarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    margin-top: 50px;
    margin-bottom: 50px;
`;

const NameWrapper = styled.div`
margin-top: 80px;
  ${props =>
        props.width &&
        css`
      width: ${props.width};
    `}
`;


const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;

const HeaderWrapper = styled(FlexWrapper)`
    // display: inline;
    margin-left: 250px;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const BannedImageParentDiv = styled.div`

    
`;

const ChromeImageParent = styled.img`
    width: 20px;
    height: 20px;
    border-radius: 35px;
    position: absolute;
    cursor: pointer;
    visibility: hidden;
    ${BannedImageParentDiv}:hover & {
        visibility: visible;
    }
    margin-left: 5px;
    margin-top: 5px;
`;

const DeleteImageParent = styled.img`
    width: 20px;
    height: 20px;
    border-radius: 35px;
    position: absolute;
    cursor: pointer;
    visibility: hidden;
    ${BannedImageParentDiv}:hover & {
        visibility: visible;
    }
    margin-left: 6px;
    margin-top: 125px;
`;

const CropImageIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-top: -35px;
  margin-left: 115px;
  background-color: #ffffff;
  border: solid 3px #ffffff;
  display: flex;
  border-radius: 35px;
  position: absolute;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  visibility: hidden;
  ${BannedImageParentDiv}:hover & {
    visibility: visible;
  }
`;

const HeartParent = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 8%;
  margin-top: -10.5%;
  background-color: #ffffff;
  border: solid 3px #9b9b9b;
  position: absolute;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  visibility: hidden;
  ${props =>
        props.selected &&
        css`
      border: solid 3px #53e03f;
    `}
  ${BannedImageParentDiv}:hover & {
    visibility: visible;
  }
`;

const InsideImageStyle = styled.img`
  width: 15px;
  height: 15px;
`;


const Banned = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const handleLeftNavAppChange = (name) => {
        setAppName(name)
    };
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const totalPages = useRef(1);
    const [displayPageModal, setDisplayPageModal] = useState(false);
    const [bannedImages, setBannedImages] = useState([]);
    const [dropDownOptions, setDropDownOptions] = useState([])
    const [banOption, setBanOption] = useState('All')
    const [displayBanOptionModal, setDisplayBanOptionModal] = useState(false)
    const [approvedProfiles, setApprovedProfiles] = useState([])
    const [rejectedProfiles, setRejectedProfiles] = useState([])
    const [inappropriateProfiles, setInappropriateProfiles] = useState([])
    const [showCropImage, setShowCropImage] = useState(false)
    const [cropPhoto, setCropPhoto] = useState('');
    const [decoyImages, setDecoyImages] = useState(false)
    const dragOverItem = useRef();
    const dragImageUrl = useRef();

    const openGoogleImages = (imageUrl) => {
        navigator.clipboard.writeText(imageUrl);
        window.open('https://www.google.com/imghp', '_blank');
    }

    const handlePageChange = (direction) => {
        if (direction === 'next') {
            if (page < totalPages.current) {
                setPage(parseInt(page) + 1);
            }
        } else {
            if (page > 1) {
                setPage(parseInt(page) - 1);
            }
        }

    }

    const goToPage = (pageNumber) => {
        if (pageNumber <= totalPages.current && pageNumber >= 1) {
            setPage(pageNumber);
        }
        setDisplayPageModal(false);
    }

    const closeModal = () => {
        setDisplayPageModal(false);
    }

    const fetchDropDownValues = async () => {
        setLoading(true);
        let response = await authorizedHttpGet('members/fetch_state_history_dropdown_values')
        setDropDownOptions(response.data)
        totalPages.current = response.data.total_pages;
        setLoading(false);
    };

    const fetchBannedInfo = async () => {
        setLoading(true);
        let response = await authorizedHttpGet(urls.GET_BANNED, { "page": page, "ban_reason": banOption });
        if (response.status) {
            totalPages.current = response.data.total_pages;
            setBannedImages(response.data.profile_list);
        }
        setLoading(false);
    }

    const getBanOption = (option) => {
        setBanOption(option)
        setDisplayBanOptionModal(false)
    }

    useEffect(() => {
        fetchBannedInfo();
    }, [page, appName, banOption]);

    useEffect(() => {
        fetchDropDownValues();
        setPage(1);
    }, [appName]);

    const handleAction = (profile, action) => {
        if (action === 'approve') {
            if (checkIfRefExists(profile.ref, 'approve')) {
                let remove_profile = approvedProfiles.filter((item) => item.ref !== profile.ref)
                setApprovedProfiles(remove_profile)
                return;
            }
            setApprovedProfiles([...approvedProfiles, profile])
            let remove_profile = rejectedProfiles.filter((item) => item.ref !== profile.ref)
            setInappropriateProfiles(inappropriateProfiles.filter((item) => item.ref !== profile.ref))
            setRejectedProfiles(remove_profile)
        } else if (action === 'disapprove') {
            if (checkIfRefExists(profile.ref, 'disapp')) {
                let remove_profile = rejectedProfiles.filter((item) => item.ref !== profile.ref)
                setRejectedProfiles(remove_profile)
                return;
            }
            let remove_profile = approvedProfiles.filter((item) => item.ref !== profile.ref)
            setApprovedProfiles(remove_profile)
            setInappropriateProfiles(inappropriateProfiles.filter((item) => item.ref !== profile.ref))
            setRejectedProfiles([...rejectedProfiles, profile])
        } else {
            if (checkIfRefExists(profile.ref, 'inapp')) {
                let remove_profile = inappropriateProfiles.filter((item) => item.ref !== profile.ref)
                setInappropriateProfiles(remove_profile)
                return;
            }
            let remove_profile = approvedProfiles.filter((item) => item.ref !== profile.ref)
            setApprovedProfiles(remove_profile)
            remove_profile = rejectedProfiles.filter((item) => item.ref !== profile.ref)
            setRejectedProfiles(remove_profile)
            setInappropriateProfiles([...inappropriateProfiles, profile])
        }
    }

    const checkIfRefExists = (ref, type) => {
        let exists = false;
        if (type === 'approve') {
            approvedProfiles.forEach((item) => {
                if (item.ref === ref) {
                    exists = true;
                }
            })
        } else if (type === 'disapp') {
            rejectedProfiles.forEach((item) => {
                if (item.ref === ref) {
                    exists = true;
                }
            })
        } else {
            inappropriateProfiles.forEach((item) => {
                if (item.ref === ref) {
                    exists = true;
                }
            })
        }
        return exists;
    }

    const saveData = async () => {
        setLoading(true);
        const visibleRefs = bannedImages.map((profile) => profile.ref).filter(Boolean);
        let response = await authorizedHttpPost(
            urls.APPROVE_DISAPPROVE,
            {
                "approve": approvedProfiles,
                "disapprove": rejectedProfiles,
                "inappropriate": inappropriateProfiles,
                "visible_refs": visibleRefs
            }
        );
        if (response.status) {
            setApprovedProfiles([])
            setRejectedProfiles([])
            setInappropriateProfiles([])
            fetchBannedInfo();
        }
    }

    const deleteImages = (ref, photo_id) => {
        bannedImages.forEach((item) => {
            if (item.ref === ref) {
                if (item.photos.length === 1) {
                    return;
                }
                let new_photos = item.photos.filter((photo) => photo.photo_id !== photo_id)
                item.photos = new_photos;
                setDecoyImages(!decoyImages)
            }
        })
    }

    const addImage = (event, ref) => {
        const file = event.target.files[0];
        // props.addImage(URL.createObjectURL(file));
        const reader = new FileReader();

        reader.onload = (e) => {
            const base64String = e.target.result.split(',')[1];
            const imageData = `data:image/jpeg;base64,${base64String}`
            bannedImages.forEach((item) => {
                if (item.ref === ref) {
                    if (item.photos.length === 4) {
                        return;
                    }
                    let new_photos = item.photos;
                    new_photos.push({ "photo": imageData })
                    item.photos = new_photos;
                    setDecoyImages(!decoyImages)
                }
            })
        };

        reader.readAsDataURL(file);
    }

    const checkIfPhotoSelected = (photo_id, ref) => {
        let selected = false;
        bannedImages.forEach((item) => {
            if (item.ref === ref) {
                item.photos.forEach((photo) => {
                    if (photo.photo_id === photo_id) {
                        if (photo['selected']) {
                            selected = true;
                        }
                    }
                })
            }
        })
        return selected;
    }

    const selectImage = (photo_id, ref) => {
        bannedImages.forEach((item) => {
            if (item.ref === ref) {
                item.photos.forEach((photo) => {
                    if (photo.photo_id === photo_id) {
                        photo['selected'] = true
                    } else {
                        photo['selected'] = false
                    }
                })
            }
        })
        setDecoyImages(!decoyImages)
    }

    const dragStart = (e, position, url) => {
        dragImageUrl.current = url;
        dragOverItem.current = position;
    };

    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };

    const dropImage = (ref) => {
        setDecoyImages(!decoyImages);
        if (dragOverItem.current !== null) {
            bannedImages.forEach((item) => {
                if (item.ref === ref) {
                    item.photos[dragOverItem.current] = { "photo": dragImageUrl.current };
                }
            })
            dragImageUrl.current = null;
            dragOverItem.current = null;
        }
    }

    const showImageCrop = (photo, index, ref) => {
        setCropPhoto(photo)
        setShowCropImage(true);
        sessionStorage.setItem('cropRef', ref)
        sessionStorage.setItem('cropIndex', index)
    }

    const saveCroppedImage = (croppedImage) => {
        console.log('Cropped image received in parent component');
        // setDecoyImages(!decoyImages);
        // bannedImages.forEach((item) => {
        //     if (item.ref === sessionStorage.getItem('cropRef')) {
        //         item.photos[sessionStorage.getItem('cropIndex')] = { "photo": croppedImage }
        //     }
        // })
        // setShowCropImage(false);
        saveCroppedImageWithPresignedUrl(croppedImage);
    }

    const saveCroppedImageWithPresignedUrl = async (croppedImage) => {
        console.log('Saving cropped image to S3...');
        const ref = sessionStorage.getItem('cropRef');
        const index = sessionStorage.getItem('cropIndex');
        try {
            setLoading(true);
            const s3Url = await uploadCroppedImageToS3(croppedImage, ref);
            bannedImages.forEach((item) => {
                if (item.ref === ref) {
                    item.photos[index] = { "photo": s3Url }
                }
            })
            setShowCropImage(false);
            setDecoyImages((prev) => !prev);
        } catch (e) {
            console.error('Failed to save cropped image', e);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="App">
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Banned'} />
            <div className="bannedMainDiv">
                {loading && <Loader />}
                {displayBanOptionModal && <BannedOptionsModal closeModal={() => setDisplayBanOptionModal(false)} reportOptions={dropDownOptions} getBanOption={getBanOption} />}
                {displayPageModal && <PageModal goToPage={goToPage} page={page} closeModal={closeModal} />}
                {showCropImage ? <CropImage photo={cropPhoto} closeModal={() => setShowCropImage(false)} saveCroppedImage={saveCroppedImage} /> : null}
                <FlexWrapper className="marginTop25">
                    <HeaderWrapper className="cursorPointer" onClick={() => setDisplayPageModal(true)}>
                        <HeaderSelected className="marginLeft10">{page}</HeaderSelected>
                        <HeaderSelected className="marginLeft10">{totalPages.current}</HeaderSelected>
                    </HeaderWrapper>
                    <HeaderWrapper onClick={() => setDisplayBanOptionModal(true)} className="marginLeft10">
                        <HeaderSelected>{banOption}</HeaderSelected>
                    </HeaderWrapper>
                </FlexWrapper>
                <div className="bannedImages">
                    {
                        bannedImages.map((image) => (
                            <>
                                <div className="bannedImagesDiv">
                                    {
                                        [0, 1, 2, 3].map((photo, index) => (
                                            <div
                                                key={index}
                                                onDragStart={(e) => dragStart(e, index, image.photos[photo].photo)}
                                                onDragEnter={(e) => dragEnter(e, index)}
                                                onDragEnd={() => dropImage(image.ref)}>
                                                {
                                                    image.photos[photo] ?
                                                        <BannedImageParentDiv>
                                                            <DeleteImageParent onClick={() => deleteImages(image.ref, image.photos[photo].photo_id)} src={delete_image} />
                                                            <ChromeImageParent onClick={() => openGoogleImages(image.photos[photo].photo)} alt="chrome" src={chrome_icon} />
                                                            <img alt={image.photos[photo].photo} src={getSafeMediaUrl(image.photos[photo].photo, place_holder)} onError={(e) => e.target.src = place_holder} className="bannedImageStyles" />
                                                            <HeartParent selected={checkIfPhotoSelected(image.photos[photo].photo_id, image.ref)} onClick={() => selectImage(image.photos[photo].photo_id, image.ref)}>
                                                                {
                                                                    checkIfPhotoSelected(image.photos[photo].photo_id, image.ref) ? <InsideImageStyle src={heart} /> : null
                                                                }
                                                            </HeartParent>
                                                            < CropImageIcon onClick={() => {
                                                                showImageCrop(image.photos[photo].photo, index, image.ref)
                                                            }}>
                                                                <InsideImageStyle src={crop_icon} />
                                                            </CropImageIcon>
                                                        </BannedImageParentDiv> :
                                                        <InputParentDiv>
                                                            <Image src={add_icon} alt="Add" />
                                                            <InputImage id="fileInput" type="file" onChange={(e) => addImage(e, image.ref)} />
                                                        </InputParentDiv>
                                                }
                                            </div>
                                        ))
                                    }

                                    {image.selfie_url ? <img alt={image.selfie_url} src={getSafeMediaUrl(image.selfie_url, place_holder)} onError={(e) => e.target.src = place_holder} className="bannedImageStyles" /> : <img src={no_image_available} className="bannedImageStyles" />}
                                </div>
                                <NameWrapper>
                                    <CommonTextStyleSpan highlight>
                                        {getDate(image.banned_time)}
                                    </CommonTextStyleSpan>
                                    <br />
                                    <CommonTextStyleSpan>
                                        {image.curator} <br /> {image.ref}{' '}
                                    </CommonTextStyleSpan>
                                </NameWrapper>
                                <div className="actionButtonBannedDiv">
                                    <ActionButton green={checkIfRefExists(image.ref, 'approve')} onClick={() => handleAction(image, 'approve')}>A</ActionButton>
                                    <ActionButton red={checkIfRefExists(image.ref, 'disapp')} onClick={() => handleAction(image, 'disapprove')}>D</ActionButton>
                                    <ActionButton black={checkIfRefExists(image.ref, 'inapp')} onClick={() => handleAction(image, 'inappropriate')}>I</ActionButton>
                                </div>
                            </>
                        ))
                    }
                </div>
                {
                    bannedImages.length > 0 &&
                    <BottomBarWrapper>
                        {page === 1 ? <img alt="previous_inctive" src={previous_inctive} className="cursorPointer" /> : <img alt="previous_active" src={previous_active} onClick={() => handlePageChange('previous')} className="cursorPointer" />}
                        {page === totalPages.current ? <img alt="next_inactive" className="nextInctiveStyle" src={next_inactive} onClick={() => handlePageChange('next')} /> : <img className="nextInctiveStyle" alt="next_active" src={next_active} onClick={() => handlePageChange('next')} />}
                    </BottomBarWrapper>
                }
                {
                    bannedImages.length > 0 &&
                    <BaseButton onClick={saveData} green>Save</BaseButton>
                }
                {
                    bannedImages.length === 0 && <EmptyView />
                }
            </div>
        </div>
    );
}

export default Banned;
